import moment from 'moment';

import { type BoardCardLayoutProps } from 'app/main/components/page-layouts/view/kanban/components/BoardList';
import { FormattedDateTimeRange, Icon, ImageAvatar, MultiButton, SquareChip, useSettings } from 'app/main/components';
import BoardCard from 'app/main/components/page-layouts/view/kanban/components/BoardCard';
import buttons from './OpportunitiesButtons';

export default function OpportunitiesKanbanCard({ model, buttonProps, provided, snapshot }: BoardCardLayoutProps) {
	const { t } = useSettings();

	const isExpiring =
		[1, 2].includes(model.oppo_opst_id) && model.oppo_d_to
			? moment(model.oppo_d_to).isSameOrAfter(moment().startOf('day').utc()) &&
				moment(model.oppo_d_to).isSameOrBefore(moment().startOf('day').utc().add(7, 'day'))
			: false;

	const isExpired =
		[1, 2].includes(model.oppo_opst_id) && model.oppo_d_to
			? moment(model.oppo_d_to).isBefore(moment().startOf('day').utc())
			: false;

	return (
		<BoardCard
			title={`${model.oppo_title}${model.comp_title ? ` - ${model.comp_title}` : ''}`}
			avatar={
				model.oppo_user_assigned_uid && (
					<ImageAvatar
						dimensions={36}
						module="users"
						uid={model.oppo_user_assigned_uid}
						avatar={model.user_assigned_avatar}
						initials={model.oppo_title_initials}
					/>
				)
			}
			action={<MultiButton buttonProps={buttonProps} items={buttons.view?.itemButtons || []} />}
			provided={provided}
			snapshot={snapshot}
		>
			{model.opty_title && (
				<div>
					<SquareChip label={model.opty_title} backgroundColor={model.opty_color} />
				</div>
			)}
			<div>
				<SquareChip
					label={
						model.oppo_d_from || model.oppo_d_to
							? FormattedDateTimeRange({ from: model.oppo_d_from, to: model.oppo_d_to })
							: t('VIEW_ITEM_NO_DATES')
					}
					icon={<Icon icon="clock" size={16} />}
					backgroundColor={theme =>
						isExpired ? theme.palette.error.main : isExpiring ? theme.palette.warning.main : undefined
					}
					disabled={!model.oppo_d_from && !model.oppo_d_to}
				/>
			</div>
		</BoardCard>
	);
}
